<template>
	<div id="pg1">
		<section  class="eres-capacitador">
			<img v-responsive.xl.lg src="@/assets/landing/capacitador/home/HOME1 1680x1050.png"
				 class="section_img">
			<img v-responsive.md src="@/assets/landing/capacitador/home/HOME1 1024x768.jpg"
				 class="section_img">
			<img v-responsive.xs.sm src="@/assets/landing/capacitador/home/HOME1 768x1024.jpg"
				 class="section_img">

			<div class="hyper-link">
				<div :class="isMobile ? 'row justify-content-center' : 'row'" >
					<div class="col-10 col-md-5">
						<h2 :class="isMobile ? 'font-blue text-center' : 'font-blue'" :style="isMobile ? 'font-size:20px;' : ''">¡Qué esperas!</h2>
						<input type="email" :class="isMobile ? 'form-control form-control-sm' : 'form-control'"
							   v-model="email.val"
							   id="send_email"
							   placeholder="Escribe tu dirección de correo">
					</div>
					<div class="col-10 col-md-5">
						<center>
							<h2 id="titleButtonEmail" style="color: transparent">¡!</h2>
							<button id="buttonEmail"
									type="submit"
									:class="isMobile ? 'btn b-orange w-50 align-center' : 'btn b-orange w-70'"
									@click.prevent="sendEmail"
									:style="isMobile ? 'margin-top: -60px;' : ''">
								<b-spinner v-show="sendLoading" small label="Espere ..."/>
								¡Comienza Ahora!
							</button>
						</center>
					</div>
				</div>

			</div>
			<!-- <div id="down">
				<div class="center">
					<img src="@/assets/landing/arrow-down.gif" width="50px">
				</div>
			</div> -->
			<div id="porqueKllaarcom"  >

				<div class="center">

					<b-button v-b-modal.porquekllaar class="b-transparent m-3">
						<span class="h2 text-white">Por qué Kllaar.com</span>
					</b-button>

				</div>
			</div>


		</section>
		<b-modal id="porquekllaar" centered hide-footer hide-header size="lg">
			<img src="@/assets/landing/empleador/home/por_que_kllaar.jpg"  class="img-fluid" alt="Responsive image" style="transparent">
			<center>
				<a href="/acerca-de" class="btn b-orange" style="margin-top:-110%;">
					Conoce más
				</a>
			</center>		
		</b-modal>


	</div>
</template>

<script>
export default {
	name: "home",
	data() {
		return {
			isMobile: this.$mobile(), 
			sendLoading: false,
			email: {
				valid: null,
				val: ""
			},
		}
	},

	watch: {
		email: {
			deep: true,
			handler() {

				if (this.email.val && this.email.val.length > 1) {
					let regx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					this.email.val !== null && this.email.val !== "" && regx.test(this.email.val)
						? (this.email.valid = true)
						: (this.email.valid = false);
				}
			}
		},
	},
	methods: {

		sendEmail() {

			this.sendLoading = true

			if (this.email.valid) {

				this.api.post('trainer/subscribe', {
					email: this.email.val
				}).then(({data}) => {
					this.sendLoading = false
					this.email = {
							valid: null,
							val: ""
						}
					this.toast(data.data, 'success')
					return false
				}).catch(err => {
					this.sendLoading = false
					if (err) {
						this.toast(data.errors.general, 'danger')
						return false
					}
				})

			} else {
				this.toast('Email requerido', 'warning')
				this.sendLoading = false
			}

		},
		toast(msg, variant) {
			this.$bvToast.toast(msg, {
				title: "Kllaar.com",
				variant: variant,
				toaster: 'b-toaster-bottom-right',
				solid: true,
				appendToast: true
			})
		}
	}
}
</script>
<style scoped lang="scss">
.section_img {
	width: 100%;
	z-index: 1;
}
.eres-capacitador{
	position:relative;
}
.eres-capacitador .hyper-link a{
	font-size: large;
}

.eres-capacitador #porqueKllaarcom{
	position: absolute;
	bottom: -76px;
	right:0;
	z-index:3;
	width: 100%;
	background: #00366a;
	color: #fff;
}
.eres-capacitador #down{
	position: absolute;
	bottom: -10%;
	right:0;
	z-index:3;
	width: 100%;
	img{
		cursor: pointer;
	}
}
.center {
	width: 100%;
	height: 100%;
	text-align: center;
}
.eres-capacitador .hyper-link{
	position: absolute;
	bottom: 20%;
	right: 10%;
	width: 40%;
	z-index: 2;

	@media only screen and (min-width: 320px)  and (max-device-width: 581px)  {
		top: 70%;
		width: 80%;
		#buttonEmail{
			min-width: 65%;
		}
	}
	@media only screen and (min-width: 768px) {
		bottom: 23%;
		right: 4%;
		width: 80%;
	}
	@media only screen and (min-width: 960px) {
		bottom: 20%;
		right: 2%;
		width: 56%;
	}
	@media only screen and (min-width: 1440px) {
		bottom: 20%;
		width: 44%;
	}
	@media only screen and (min-width: 2000px) {
		bottom: 20%;
		width: 44%;
	}
	@media only screen and (max-device-width: 480px) {
		bottom: 15%;
		width: 80%;
	}
	@media only screen and (device-width: 768px) {
		bottom: 15%;
		width: 80%;
	}
	/* different techniques for iPad screening */
	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
		bottom: 15%;
		width: 80%;
	}

	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
		/* For landscape layouts only */
		bottom: 15%;
		width: 80%;
	}
}

</style>


<!--<style scoped lang="scss">-->

<!--.section_img {-->
<!--	width: 100%;-->
<!--}-->

<!--/**-->
<!--  hyper-link:-->
<!-- */-->
<!--.hyper-link {-->
<!--	position: absolute;-->
<!--	//border: #0b2e13 1px solid;-->
<!--	width: 100%;-->
<!--	right: 0;-->

<!--	@media only screen and (min-width: 480px) {-->
<!--		top: 83vw;-->
<!--	}-->
<!--	@media only screen and (min-width: 768px) {-->
<!--		top: 55vw;-->
<!--	}-->

<!--	@media only screen and (min-width: 960px) {-->
<!--		top: 47vw; //top: 52vw;-->
<!--	}-->
<!--	@media only screen and (min-width: 1440px) {-->
<!--		top: 41.5vw;-->
<!--	}-->
<!--	@media only screen and (min-width: 2000px) {-->
<!--		top: 35vw;-->
<!--	}-->
<!--	@media only screen and (max-device-width: 480px) {-->
<!--		top: 75vw;-->
<!--	}-->
<!--	@media only screen and (device-width: 768px) {-->
<!--		top: 44vw;-->
<!--	}-->
<!--	///* different techniques for iPad screening */-->
<!--	//@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {-->
<!--	//	top: 83vw;-->
<!--	//}-->
<!--	//-->
<!--	//@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {-->
<!--	//	/* For landscape layouts only */-->
<!--	//	top: 41vw;-->
<!--	//}-->
<!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/views/landing/capacitador/home.vue